import type { ReactNode } from "react";
import { QueryProvider } from "@app/providers/query-provider";
import { ThemeProvider } from "@app/providers/theme-provider";
import { SessionProvider } from "@app/providers/session-provider";
import { PlatformProvider } from "@app/providers/platform-provider";
import { GuestCountryDetector } from "@app/components/guest-country-detector";
import { Toaster } from "@components/ui/sonner";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <PlatformProvider>
      <QueryProvider>
        <ThemeProvider>
          <SessionProvider>
            {children}
            <GuestCountryDetector />
            <Toaster
              position="top-center"
              // sonner writes offset/mobileOffset to every edge, and below
              // 600px it reads only --mobile-offset-* — so both props are
              // required. Setting offset alone leaves phones at the 16px
              // default, which lands inside the notch / status bar.
              // Unlisted edges fall back to sonner's defaults, preserving the
              // symmetric mobile gutter: each toast sizes itself to
              // calc(100% - var(--mobile-offset-left) * 2).
              offset={{ top: "calc(var(--safe-area-top) + 1rem)" }}
              mobileOffset={{ top: "calc(var(--safe-area-top) + 0.75rem)" }}
              richColors
            />
          </SessionProvider>
        </ThemeProvider>
      </QueryProvider>
    </PlatformProvider>
  );
}
